import { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { isRegisterVisibleSelector } from "@client/widgets/SidePanel/selectors";
import Component from "./component";

const mapStateToProps = (state: AppState): WithIsVisibleHOCProps => {
  const isVisible = isRegisterVisibleSelector(state);
  return {
    isVisible
  };
};

export default connectCustom(mapStateToProps)(Component);
